import { localizedPath } from "@shared/lib/localized-path";

type AuthLegalPage = "terms" | "privacy";

export function getAuthLegalHref(page: AuthLegalPage, pathname?: string): string {
  return localizedPath(`/${page}`, pathname);
}
